import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPpis } from '../actions';
import { getIsFetching, getPpisWithStatus } from '../selectors';

const usePpis = (withStatus, secondStatus) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const ppisWithStatus = useSelector(
    getPpisWithStatus(
      withStatus === 'COPYLOCAL' ? 'PUBLISHED' : withStatus,
      secondStatus
    )
  );

  useEffect(() => {
    const filter = {};
    if (withStatus) {
      filter.status = withStatus;
    }
    dispatch(fetchPpis({ filter }));
  }, [dispatch, withStatus]);

  return [isFetching, ppisWithStatus];
};

export default usePpis;
